import React, { useState, useMemo, useEffect } from "react";
import { Checkbox, Table as AntdTable } from "antd";
import "./styles.scss";

const HiddenColumnsTable = ({
  columns,
  dataSource,
  rowClickFunction,
  onVisibleColumnsChange,
  scrollX = "max-content",
  headerActions = null,
  highlightRowKey = null,
}) => {
  const [checkedList, setCheckedList] = useState(
    columns.filter((col) => !col.hideCheckbox).map((item) => item.key),
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [selectedRowKey, setSelectedRowKey] = useState(null);

  const options = columns
    .filter((column) => !column.hideCheckbox)
    .map(({ key, title, label }) => ({
      label: label ?? title,
      value: key,
    }));

  useEffect(() => {
    if (onVisibleColumnsChange) {
      const visibilityMap = {};
      columns.forEach((col) => {
        if (!col.hideCheckbox) {
          visibilityMap[col.key] = checkedList.includes(col.key);
        }
      });

      onVisibleColumnsChange(visibilityMap);
    }
  }, [checkedList]);

  const updatedColumns = useMemo(
    () => [...columns],
    [currentPage, perPage, columns],
  );

  const newColumns = updatedColumns.map((item) => {
    if (item.hideCheckbox || item.key === "rowIndex") {
      return {
        ...item,
        hidden: false,
      };
    }
    return {
      ...item,
      hidden: !checkedList.includes(item.key),
    };
  });

  return (
    <div className="chart-table-separator">
      <div>
        <div className="columns-selection-area">
          <Checkbox.Group
            value={checkedList}
            options={options}
            onChange={(value) => setCheckedList(value)}
          />
          {headerActions ? (
            <div className="columns-selection-actions">{headerActions}</div>
          ) : null}
        </div>
        <div className="hidden-columns-table-container">
          <AntdTable
            columns={newColumns.filter((col) => !col.hidden)}
            dataSource={dataSource}
            rowClassName={(record) => {
              const classes = [];
              if (record.key === selectedRowKey) classes.push("row-selected");
              if (highlightRowKey && record.key === highlightRowKey) {
                classes.push("row-diagnosis-open");
              }
              return classes.join(" ");
            }}
            onRow={(record) => ({
              onClick: () => {
                if (selectedRowKey === record.key) {
                  setSelectedRowKey(null);
                  rowClickFunction(null);
                } else {
                  setSelectedRowKey(record.key);
                  rowClickFunction(record);
                }
              },
            })}
            style={{ marginTop: 16, width: "100%" }}
            scroll={scrollX ? { x: scrollX } : undefined}
            tableLayout={scrollX ? undefined : "fixed"}
            pagination={{
              current: currentPage,
              pageSize: perPage,
              onChange: (page, pageSize) => {
                setCurrentPage(page);
                setPerPage(pageSize);
              },
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HiddenColumnsTable;
